document.addEventListener("DOMContentLoaded", function() {
    // Scroll to next section
    const scrollToNextBtn = document.getElementById("scrollToNextBtn");
    const currentSection = document.querySelector(".cust_banner_sec");
    if(scrollToNextBtn){
        scrollToNextBtn.addEventListener("click", function() {
            const nextSection = currentSection.nextElementSibling;
            if (nextSection) {
                nextSection.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        });
    }
    // Scroll to next section

    // Index banner slide
    const indexbannerMain = document.querySelector('.index_bannerMain');
    if (indexbannerMain) {
    const banner_splide = new Splide('.index_bannerMain', {
        type: 'slide',
        direction: 'ttb',      // vertical for desktop
        height: "100vh",
        autoHeight: true,
        autoplay: true,
        interval: 5000,
        speed: 1000,
        pauseOnHover: false,
        arrows: false,
        wheel: false,
        releaseWheel: true,
        wheelMinThreshold: 30,
        wheelSleep: 800,
        breakpoints: {
            1199: {
                direction: 'ltr',  // horizontal for small screens
                height: "auto",    // adjust height for horizontal
                autoHeight: false,
            },
            767: {
                pagination: false,
            }
        }
    }).mount();
    }
    // Index banner slide

    // Featured blog slide
    const indexBlogMain = document.querySelector('.index_blogMain');

    if (indexBlogMain) {
        // Initialize the Splide slider
        const blog_splide = new Splide('.index_blogMain', {
            type       : 'loop',
            autoplay  : false,
            interval  : 3000,
            pauseOnHover: false,
            perPage   : 3,
            gap       : '3rem',
            pagination: false,
            breakpoints: {
                1200: {
                    perPage: 3,
                    gap       : '2rem',
                },
                768: {
                    perPage: 2,
                },
                480: {
                    perPage: 1,
                }
            }
        }).mount(); // Mount the Splide instance

        // Custom arrow click events
        const prevButton = document.querySelector('.cust_arrowWrap .splide__arrow--prev');
        const nextButton = document.querySelector('.cust_arrowWrap .splide__arrow--next');

        if (prevButton && nextButton) {
            prevButton.addEventListener('click', function () {
                blog_splide.go('prev');
            });

            nextButton.addEventListener('click', function () {
                blog_splide.go('next');
            });
        }
    }
    // Featured blog slide

    // Add has-sec-banner class to the body if .sec-top-banner class exists
    var mainTag = document.querySelector('main');
    if (mainTag) {
      // Find the first .shopify-section inside the main tag
      var firstShopifySection = mainTag.querySelector('.shopify-section');

      // Check if this first .shopify-section contains the .sec-top-banner class
      if (firstShopifySection && firstShopifySection.classList.contains('cust_banner_sec')) {
        document.body.classList.add('has-custom-banner');
      }
    }
    // Featured blog slide

    // Index accordion
    const accordionItem = document.querySelectorAll(".cust_imgText_main .accordionItem");
    if (accordionItem.length > 0){

        const first_item = accordionItem[0];
        const first_faq_qus = first_item.querySelector(".accordion_title");
        const first_faq_ans = first_item.querySelector(".accordion_text");

        if (first_faq_qus && first_faq_ans){
            first_item.classList.add("open");
            first_faq_qus.classList.add("active");
            first_faq_ans.style.height = first_faq_ans.scrollHeight + "px";
        }

        accordionItem.forEach((item) => {
            const faq_qus = item.querySelector(".accordion_title");
            const faq_ans = item.querySelector(".accordion_text");

            if (faq_qus && faq_ans){
                faq_qus.addEventListener("click", function(){

                    // if already open, do nothing
                    if(item.classList.contains("open")){
                        return;
                    }

                    accordionItem.forEach(i =>{
                        const qus = i.querySelector(".accordion_title");
                        const ans = i.querySelector(".accordion_text");

                        if (qus && ans){
                            i.classList.remove("open");
                            qus.classList.remove("active");
                            ans.style.height = 0;
                        }
                    });

                    item.classList.add("open");
                    faq_qus.classList.add("active");
                    faq_ans.style.height = faq_ans.scrollHeight + "px";
                });
            }
        });
    }
    // Index accordion
});


// Get Header Height
function updateHeaderHeight() {
  const headerBar = document.querySelector('.header-wrapper');
  if (headerBar) {
    const height = headerBar.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${height}px`);
  }
}
document.addEventListener("DOMContentLoaded", function() {
  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight);
});